import React, {ReactElement, useState, useEffect, useRef, useMemo} from 'react';
import Error from 'next/error';
import dynamic from 'next/dynamic';

import MainLayout from 'components/layout/mainLayout';

import config from 'settings/config';

import getTemplateData from 'utils/getTemplateData';
import storyblokService from 'services/storyblokService.js';


const BlogListPage = dynamic(() => import('components/pages/blog/blogListPage'), {});
const BlogArticlePage = dynamic(() => import('components/pages/blog/blogArticlePage'), {});



const Page = (props) => {

  // Page Load
  useEffect(() => {
    storyblokService.initEditor(null);
  }, [])

  // Errors
  if (props.statusCode > 299) {
    return <Error statusCode={props.statusCode} />;
  }
  if(props.mode === 'list'){
    return (
      <BlogListPage {...props} />
    );
  }
  else if(props.mode === 'article'){
    return (
      <BlogArticlePage {...props} />
    );
  }
  else{
    return <div>No List or Article</div>;
  }

}

Page.getLayout = (page: ReactElement) => {
  return (
    <MainLayout masterTemplateData={page.props.masterTemplateData}>
      {page}
    </MainLayout>
  )
}

export default Page




// Static Props
export async function getServerSideProps({ params, preview = false, previewData = {} }) {

  let slug = params.slug && params.slug.length > 0 ? params.slug[0] : '';
  let mode = isNaN(slug) ? 'article' : 'list';

  let statusCode = 200;

  // List Mode
  if(mode==='list'){

    let results;

    try {
      results = await Promise.all([
        getTemplateData(),
        storyblokService.get(`cdn/stories/blog`, {}),
        storyblokService.get(`cdn/stories`, {
            page: parseInt(slug) || 1,
            per_page: config.blog.resultsPerPage,
            with_parent: 8532192,
            filter_query: {
                "component": {
                    "in": "blog-post"
                }
            },
            sort_by: 'content.date:desc',
            excluding_fields: 'content'
        })
      ])
    } catch (error) {
      return {
        // revalidate: 1, -- Put this back if moving back to static props
        props: { statusCode: error.response ? error.response.status : 500}
      };
    }

    const masterTemplateData = results[0] ?? null;
    const pageData = results[1]?.data?.story ?? null;
    const records = results[2]?.data?.stories ?? null;

    // If there are no results we 404
    if(records === undefined || (Array.isArray(records) && records.length === 0)){
      return {
        props: { statusCode: 404}
      };
    }
    

    // Hack because last items keeps going missing
    masterTemplateData.content.top_menu_categories.push({})

    let meta = {
      resultsPerPage: results[2]?.perPage ?? 0,
      totalCount: results[2]?.total ?? 0
    } 

    return {
      // revalidate: 1, -- Put this back if moving back to static props
      props: { 
          statusCode,
          slug,
          mode,
          masterTemplateData,
          pageData,
          meta,
          records
      }
    };

  }


  // Article Mode
  else if(mode==='article'){

    // Get Data
    let results;

    try {
      results = await Promise.all([
        getTemplateData(),
        storyblokService.get(`cdn/stories/blog`, {}),
        storyblokService.get(`cdn/stories/blog/${params.slug}`, {})
      ]);
    } catch (error) {
      return {
        // revalidate: 1, -- Put this back if moving back to static props
        props: { statusCode: error.response ? error.response.status : 500}
      };
    }

    const masterTemplateData = results[0] ?? null;
    const blogPageData = results[1]?.data?.story;
    const pageData = results[2]?.data?.story;

    // Hack because last items keeps going missing
    masterTemplateData.content.top_menu_categories.push({});

    return {
      // revalidate: 1, -- Put this back if moving back to static props
      props: { 
        statusCode,
        slug,
        mode,
        masterTemplateData,
        blogPageData,
        pageData
      }
    }


  }

  else{
    return {props:{}};
  }

}



